// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  CAR_DATA_MASTER_UPDATE_BRANCH_LIST,
} from './constants';

export function updateBranchList(text) {
  return {
    type: CAR_DATA_MASTER_UPDATE_BRANCH_LIST,
    text: text
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CAR_DATA_MASTER_UPDATE_BRANCH_LIST:
      let aux = [...state.branchListOrigin];
      aux = aux.filter(branch => branch.code.toLowerCase().includes(action.text.toLowerCase()) || branch.businessName.toLowerCase().includes(action.text.toLowerCase()) || branch.cuit.toLowerCase().includes(action.text.toLowerCase()));
      return {
        ...state,
        branchList: [...aux]
      };

    default:
      return state;
  }
}
